export const formatCurrency = (amount: string | number, currency: string, showCode?: boolean): string => {
  const num = typeof amount === 'string' ? parseFloat(amount) : amount
  const code = (currency || 'MXN').toUpperCase()
  if (showCode == false) {
    return num.toLocaleString('es-MX', { style: 'currency', currency: code })
  }
  return `$${num.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${code} `
}

export const formatDate = (dateString: string): string => {
  if (!dateString) return 'N/A'
  return new Date(dateString).toLocaleDateString('es-MX', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  })
}

export const getSupplierName = (supplier: any): string => {
  if (!supplier) return 'Sin nombre'
  return supplier.legalName || supplier.mainContactName || 'Sin nombre'
}

export const getStatusLabel = (status: string): string => {
  const labels: Record<string, string> = {
    draft: 'Borrador',
    pending: 'Pendiente',
    confirmed: 'Confirmada',
    rejected: 'Rechazada',
    in_progress: 'En Progreso',
    completed: 'Completada',
    cancelled: 'Cancelada'
  }
  return labels[status] || status
}

